import { render, staticRenderFns } from "./ComposerMenuMobile.vue?vue&type=template&id=7e8cfb40&scoped=true"
import script from "./ComposerMenuMobile.vue?vue&type=script&lang=js"
export * from "./ComposerMenuMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8cfb40",
  null
  
)

export default component.exports